import router from './router'
import {
  getUserInfo
} from "@/api/login";
import {
  Toast
} from 'vant';

function getCodeApi(state) { //获取code   

  sessionStorage.setItem("state", state);

  let origin = location.href;
  if (state === '1234') {
    origin = window.location.origin;
  }
  // alert('orgin == ',origin);
  let urlNow = encodeURIComponent(origin); ///netbar/api/wechat/v1/get_open_id
  let scope = 'snsapi_base'; //snsapi_userinfo   //静默授权 用户无感知
  let appid = 'wx8e607bf041014289';
  // let appid = 'wxc223e80956b50ab8';
  let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
  let baseUrl = null
  var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    //在微信中打开
    baseUrl = url
  }
  window.location.href = baseUrl
}

function getUrlKey(name) { //获取url 参数
  // alert("location.href code = "+"====="+location.href);
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
}
// 路由变化时
router.beforeEach((to, from, next) => {
  // alert(to.meta.title+"====="+to.fullPath);
  // alert('hahah' + to.fullPath)
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  //读取sessionStorage的user
  let user = JSON.parse(sessionStorage.getItem('loginInfo'));
  // 已登录
  if (user) {
    next(); //释放路由 如果已经登录
  }
  // 未登录
  if (!user) {
    let code = getUrlKey('code'); //获取url 上面的code
    // 还未完成微信授权
    if (!code) { //假如没code
      // alert("没有code")
      getCodeApi('123'); //请求微信服务器获取code
    }
    // 已完成微信授权 假如已经获取到了code
    if (code) {
      sessionStorage.setItem("code", code);
      // alert("aaaaa code = "+sessionStorage.getItem("code"));
      let isGotoLogin = sessionStorage.getItem("isGotoLogin");

      if (!isGotoLogin) {
        //使用code 去登录
        getUserInfo({
          code: code
        }).then(
          res => {
            //console.log(res);
            if (res.code == 200) {
              sessionStorage.removeItem("code");
              // 将data转换成字符转
              // 为什么每次获取的时候sessionStroage没有覆盖掉
              let jsonLoginInfo = JSON.stringify(res.data);
              // 将数据存入到sessionStorage
              sessionStorage.setItem("loginInfo", jsonLoginInfo);
              // alert('getuserInfo获取code成功bbb');
              if (to.fullPath !== '/') {
                next()
              } else {
                if (JSON.parse(sessionStorage.getItem('loginInfo')).role == 0) {
                  next({
                    path: '/choosebar'
                  })
                } else {
                  next()
                }
              }
            } else {
              // alert("getuserInfo获取code失败eee");
              sessionStorage.setItem("isGotoLogin", true);
              sessionStorage.removeItem("code");
              sessionStorage.removeItem('loginInfo');
              getCodeApi('1234'); //请求微信服务器获取code
              next({
                path: '/login'
              })
            }
          }
        ).catch(err => {
          //  alert("fffffff",err);
          sessionStorage.setItem("isGotoLogin", true);
          sessionStorage.removeItem("code");
          sessionStorage.removeItem('loginInfo');
          getCodeApi('1234'); //请求微信服务器获取code
          next({
            path: '/login'
          })
        });
      } else {
        let state = sessionStorage.getItem("state");
        if (to.fullPath == '/') {
          sessionStorage.removeItem("state");
          sessionStorage.removeItem("code");
          sessionStorage.removeItem('loginInfo');
          next({
            path: '/login'
          })
        } else {
          next()
        }
      }
    }
  } else {
    next();
  }
});